<template>
  <footer class="c-footer">
      <div>
          <img class="c-footer__main-logo" src="@/assets/logos/logo.svg" alt="Meetrika" title="Meetrika" />
          <span class="c-footer__year"> {{new Date().getFullYear()}}</span>
      </div>
      <div class="c-footer__copyright">
          <span>{{ $t('footer.a_product')}} <span class="c-footer__copyright--bold"><a href="https://www.wearebab.com/es" target="_blank">bab - wearebab.com</a></span></span>
      </div>
  </footer>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'FooterMeetrika',
}
</script>
